import { chunk } from 'lodash';

export default (filterCallback, paginationConfig) => ({
  data() {
    return {
      listData: [],
      filteredList: [],
      searchFilter: '',
      currentPage: 1,
      pageSize: 10,
      pageSizes: [10, 20, 50, -1],
      ...paginationConfig,
    };
  },
  methods: {
    filterData() {
      this.filteredList = this.listData && this.listData.filter(filterCallback(this.searchFilter));
    },
    changePage(newPage) {
      if (newPage !== this.currentPage) {
        this.currentPage = newPage;
      }
    },
    changePageSize(newPageSize) {
      if (newPageSize !== this.pageSize) {
        this.pageSize = newPageSize;
      }
    },
    paginationConfigChanged(pagination) {
      this.changePage(pagination.page);
      this.changePageSize(pagination.pageSize);
      this.cleanProcess && this.cleanProcess();
    },
  },
  computed: {
    totalRows() {
      return (Array.isArray(this.filteredList) && this.filteredList.length) || 0;
    },
    totalPages() {
      const realValue = (this.totalRows / this.pageSize);
      const roundedValue = Math.ceil(realValue);
      return roundedValue;
    },
    paginatedData() {
      const filterParam = this.pageSize === -1 ? this.filteredList.length : this.pageSize;
      const data = chunk(this.filteredList, filterParam);
      return data[this.currentPage - 1] || [];
    },
    isEmptyList() {
      return !this.listData || this.listData.length === 0;
    },
  },
  watch: {
    searchFilter() {
      this.filterData();
    },
  },
});
